import React from 'react';
import { SECTIONS } from '@/constants/testIds';
import { IMG } from '@/lib/assets';

export default function Nosotros() {
  return (
    <section id="nosotros" data-testid={SECTIONS.nosotros} className="bg-[#F5EFE0] py-24 lg:py-32">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <span className="gold-divider font-cinzel text-[#A88340] text-xs tracking-[0.3em]">NOSOTROS</span>
        <h2 className="font-cormorant text-[#0F3527] text-4xl lg:text-5xl mt-6 mb-8 leading-tight">
          Creemos que el verdadero progreso nace de la<br className="hidden md:block" />
          <em className="italic text-[#A88340]"> observación, el aprendizaje y la mejora continua.</em>
        </h2>
        <p className="text-[#0F3527]/85 text-lg leading-relaxed max-w-3xl mx-auto">
          Por eso trabajamos para desarrollar no solo animales superiores, sino también
          herramientas, procesos y conocimientos que nos permitan mejorar continuamente y dejar
          un legado que trascienda a otros productores agropecuarios; nuestro secreto es{' '}
          <em className="italic text-[#A88340]">compartir</em>.
        </p>

        <div className="mt-16 relative overflow-hidden rounded-sm tc-grain">
          {/* background image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${IMG.sardoAdulto})` }}
          />
          {/* dark green overlay - strong for text legibility */}
          <div className="absolute inset-0 bg-[#0F3527]/95" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#082018] via-[#0F3527]/95 to-[#0F3527]/60" />

          <div className="relative text-[#F5EFE0] p-10 lg:p-14 text-left grid lg:grid-cols-5 gap-8 items-center">
            <div className="lg:col-span-3">
              <span className="font-cinzel text-[#C9A361] text-xs tracking-[0.3em]">VISIÓN</span>
              <p className="font-cormorant italic text-2xl lg:text-3xl leading-snug mt-4">
                "Construir las herramientas y el conocimiento que permitan a los productores
                agropecuarios tomar mejores decisiones, aumentar su rentabilidad y acelerar el
                progreso de la ganadería mediante datos objetivos y medibles."
              </p>
            </div>
            <div className="hidden lg:block lg:col-span-2 h-64 rounded-sm overflow-hidden border border-[#C9A361]/30 shadow-2xl">
              <img src={IMG.sardoAdulto} alt="Sardo Negro Tres Cerritos" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
